import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface SavedFilter {
  id: string;
  name: string;
  filters: Record<string, unknown>;
}

const list = (namespace: string) => http.get(`${API_ENDPOINTS.mySavedFilters}/${namespace}`);

const create = (namespace: string, name: string, filters: Record<string, unknown>) =>
  http.post(`${API_ENDPOINTS.mySavedFilters}/${namespace}`, { name, filters });

const remove = (namespace: string, id: string) => http.delete(`${API_ENDPOINTS.mySavedFilters}/${namespace}/${id}`);

const SavedFilterService = { list, create, remove };

export default SavedFilterService;
